import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { HOST } from "common-import/constants";
import { Request, VarHelper } from "common-import/helpers";

export default class UploadImageModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    list: PropTypes.array,
  };

  constructor(props) {
    super (props);

    this.state = {
      open: false,
      input: '',
      files: [],
      documents: [],
      uploading: false,
    };

    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.handleRemove = this.handleRemove.bind(this, 'index');
    this.handleFilesChange = this.handleFilesChange.bind(this);
  }

  handleRemove = (index) => {
    // e.preventDefault();
    const { documents } = this.state;
    const clone = documents.filter((item, key) => {
      if (index !== key) {
        return item;
      }
    });
    this.setState({ documents: clone });
  };

  handleFilesChange = (e) => {
    const { files, documents } = this.state;
    const newFiles = e.target.files;
    const newDocuments = this.getUrls(newFiles).map((item, index) => {
      return { id: documents.length + index, url: item };
    });
    this.setState({
      documents: [...documents, ...newDocuments],
      files: [...files, ...newFiles],
    });
  };

  getUrls = (items) => {
    const urls = [];
    for (let i = 0; i < items.length; i++) {
      urls.push(URL.createObjectURL(items[i]));
    }
    return urls;
  };

  handleUpload = async () => {
    // e.preventDefault();
    let newDocuments;
    const { files, documents } = this.state;
    newDocuments = documents.filter((item) => {
      if (item.url.indexOf('blob') === -1) {
        return item;
      }
    });
    for (let i = 0; i < files.length; i++) {
      const uploadedURL = await Request.upload(files[i]);
      newDocuments.push({id: newDocuments.length, url: uploadedURL});
    }
    this.setState({
      files: [],
      documents: newDocuments
    });
    return newDocuments;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ uploading: true });
    const data = await this.handleUpload();
    this.setState({ uploading: false });
    this.props.onSubmit(data);
  };

  onClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  componentDidUpdate(prevProps) {
    const { open, list } = this.props;
    if (open !== prevProps.open) {
      this.setState({
        open,
        documents: [...list],
      })
    }
  }

  render() {
    const classCustom = {
      "modal": "modal-custom upload-image-modal",
      "closeButton": "close-button-custom",
    };

    const { documents, uploading } = this.state;

    const renderPreview = () => {
      return documents.map((item, index) => {
        return <div key={index + 'image'} className="col-md-6 image-block">
          <embed src={item.url} type="application/pdf" height="256px" style={{width: '100%'}} />
          <button onClick={() => this.handleRemove(index)} className="btn btn-sm btn-danger">Remove this document</button>
        </div>
      })
    };

    return (
      <Modal classNames={classCustom} open={this.state.open} onClose={this.onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Upload documents</h5>
          </div>
          <div className="modal-body">
            <div className="form-group group-file-upload">
              <input onChange={this.handleFilesChange} type="file" id="upload-documents" name="upload-documents" multiple="true" style={{ display: 'none' }}/>
              <label className="btn btn-danger" htmlFor="upload-documents"><i className="fa fa-camera"> </i> Upload documents</label>
            </div>
            <div className="row preview">
              {renderPreview()}
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={this.onSubmit} disabled={uploading} className="btn btn-sm btn-primary">
              <i className="fa fa-dot-circle-o"> </i> { uploading ? 'Saving...' : 'Save' }
            </button>
            <button onClick={this.onClose} className="btn btn-sm btn-secondary">
              <i className="fa fa-ban"> </i> Close
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/custom/UploadDocumentModal.js